import React, { useState } from 'react';

// Define CSS as JavaScript objects
const ReportsPage = () => {
  // State to track the active question
  const [activeIndex, setActiveIndex] = useState(0);

  // Sample data for questions and answers
  const faqs = [
    { question: 'What is SharedVision Partners?', answer: 'SharedVision Partners is a platform designed to connect like-minded investors with curated investment opportunities. The goal is to ensure funds are utilized effectively, yielding both profits and benefits.' },
       { question: 'How do I sign up for an account?', answer: 'To sign up, visit the registration page, enter your email address, set a password, confirm it, and optionally enter a referral code to earn a $5 bonus. You’ll also need to provide a wallet address to receive funds.' },
    { question: 'Why do I need to provide my wallet address', answer: 'The wallet address is required to receive your investment returns and any bonuses earned through the referral program.' },
        { question: 'How can I withdraw my earnings?', answer: 'You can withdraw funds directly to your registered wallet address through the withdrawal option available in your account.' },
     { question: 'How long does it take to process withdrawals?', answer: 'Withdrawals are typically processed within 48hrs to 3 days, depending on network congestion and verification requirements,   withdrawals are not processed on Sundays' },
    { question: 'What is the minimum investment amount?', answer: 'The minimum investment amount is $10. This allows you to start small and gradually increase your investment as you become more comfortable with the platform.' },
    { question: 'what is Staking and how does it work', answer: 'Staking is the process of locking up your tokens to support the network’s operations, such as validating transactions. In return, you earn rewards in the form of additional tokens. The more you stake, the higher your potential rewards. On our plstform the least day for staking is 60days' },
   { question: 'Do i need a Bot to stake', answer: 'No, you do not need a bot to stake on our platform. The staking process is automated and user-friendly, allowing you to easily stake your tokens without any additional tools.' },
 {question: 'Do I need Bot for Investment', answer: 'Yes on our platform, you need a bot to invest. The bot automates the investment process, ensuring that your funds are allocated efficiently and effectively to maximize returns.'},
{question: 'How much does a Bot cost', answer: 'The cost of a bot is $5 or you can get it free with a 500,000 SVP token that you can earn on the platform. This one-time fee allows you to access the automated investment features on our platform, making it easier to manage your investments and maximize returns.but you need 100,000 SVp token to keep it live after eavery 24hrs , this you can get free on the site by doing tasks or referring people to the platform.'},
    { question: 'What are the fees associated with using SharedVision Partners?', answer: 'There are no hidden fees. The platform operates on a transparent fee structure, which is communicated during the investment process.' }, 
    { question: 'Is there a referral program?', answer: 'Yes, there is a referral program. When you refer someone using your unique referral code, both you and the person you referred receive a $1 plus 100,000 SVP token bonus once they successfully Signup and invest.' },
        { question: 'Can I change my wallet address after registration?', answer: 'For security reasons, changing your wallet address may require verification. Contact customer support for assistance' },
       { question: 'What do you invest on', answer: 'We primarily invest in real estate, focusing on daily rental apartments. We pool funds to purchase or lease apartments, renting them out to generate daily profits. Additionally, we invest in platforms like PiggyVest, as well as in IT and crypto trading.' },
    { question: 'Can I withdraw funds if I am not able to refer someone?', answer: 'the answer is yes you can' },
    { question: 'How can I join?', answer: 'To join, you’ll need a referral code. If you heard about us from someone, get the referral code from them so both of you can earn $5 each. Alternatively, you can reach out to support, and they can provide you with a random user’s referral code to use.' },
    { question: ' What happens if I forget my password?', answer: 'For security reasons, changing your wallet address may require verification. Contact customer support for assistance.' },
      { question: ' Are my funds safe with SharedVision Partners?', answer: 'Yes, SharedVision Partners carefully curates investment opportunities to ensure funds are allocated to ventures that promise great returns and minimal risk.' },
    { question: 'How long does it take to process withdrawals?', answer: 'Withdrawals are typically processed within 48hrs to 3 days, depending on network congestion and verification requirements,   withdrawals are not processed on Sundays' },
  
   
  ];

  // Toggle function to open/close answers
  const toggleAnswer = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null); // Close the answer if it's already open
    } else {
      setActiveIndex(index); // Open the clicked answer
    }
  };

  return (
    <div style={styles.faqPanel}>
      <h4 style={styles.faqHeader}>Frequently Asked Questions</h4>
      <div style={styles.faqList}>
        {faqs.map((faq, index) => (
          <div key={index} style={styles.faqItem}>
            <div
              style={{
                ...styles.question,
                ...(activeIndex === index ? styles.questionHover : {}),
              }}
              onClick={() => toggleAnswer(index)}
            >
              <p>{`${index + 1}. ${faq.question}`}</p>
            </div>
            {activeIndex === index && (
              <div style={styles.answer}>
                <p style={styles.answerText}>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  faqPanel: {
    width: '100%',
    margin: 'auto',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  faqHeader: {
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  faqList: {
    marginTop: '20px',
  },
  faqItem: {
    borderBottom: '1px solid #ddd',
    padding: '15px 0',
    fontSize: '14px',
  },
  question: {
    cursor: 'pointer',
    fontSize: '14px',
    color: '#333',
    fontWeight: 'bold',
    paddingLeft: '10px',
    transition: 'color 0.3s',
  },
  questionHover: {
    color: '#007BFF',
  },
  answer: {
    marginTop: '10px',
    paddingLeft: '30px',
    fontSize: '16px',
    color: '#555',
  },
  answerText: {
    margin: '0',
  },

  // Responsive Styles
  '@media (max-width: 768px)': {
    faqPanel: {
      padding: '15px',
    },
    faqHeader: {
      fontSize: '20px',
    },
    question: {
      fontSize: '12px',
    },
    answer: {
      paddingLeft: '20px',
    },
  },
};

export default ReportsPage;
